import theme_default from "./theme_default_default.json";
import theme_default_fa_bur from "./theme_default_fa_bur.json";

const themes = {
  theme_default,
  theme_default_fa_bur,
};

export function getConfigObjectData(type: string, slug: string) {
  const tenantSlug = (typeof CONFIG !== 'undefined') ? `${CONFIG.league}_${CONFIG.tricode}` : undefined;
  return (tenantSlug && themes[`${type}_${slug}_${tenantSlug}`]) || themes[`${type}_${slug}`];
}
